var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sections.length)?_c('div',[_c('participant-adherence-schedule-chart',{attrs:{"adherence-statistics":_vm.sections}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }